import {
  Component,
  input,
  output,
  inject,
} from '@angular/core';
import { AbstractControl, ReactiveFormsModule } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepicker, MatDatepickerModule } from '@angular/material/datepicker';
import { FloatLabelType, MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

import { LangChangeEvent, TranslateModule, TranslateService } from '@ngx-translate/core';
import { Moment } from 'moment';
import moment from 'moment';

import { environment } from '@env/environment';

import { MobileDetection } from '@personal-area/global/browser-detection';
import { I18nService } from '@personal-area/global/i18n';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

const CALENDAR_DATE_FORMATS = {
  parse: {
    dateInput: 'DD.MM.YYYY',
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'calendar-input',
  templateUrl: './calendar-input.component.html',
  styleUrls: ['./calendar-input.component.scss'],
  standalone: true,
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: environment.defaultLanguage },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: CALENDAR_DATE_FORMATS },
  ],
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    TranslateModule,
    MatIcon,
  ],
})
export class CalendarInputComponent {
  public ctrl = input.required<AbstractControl>();
  public min = input.required<Date>();
  public max = input.required<Date>();

  public readonly = input(true);
  public id = input<string>('');
  public label = input<string>('');
  public placeholder = input<string>('DD.MM.YYYY');
  public startView = input<'month' | 'year' | 'multi-year'>('month');
  public noDays = input(false);
  public isNested = input(false);
  public floatLabel =  input<FloatLabelType>('auto');

  public dateChange = output<void>();

  private readonly _i18service = inject(I18nService);
  private readonly _translateService = inject(TranslateService);
  private readonly _adapter = inject(DateAdapter<Moment>);

  readonly isMobile = MobileDetection.isMobile();

  constructor() {
    this._adapter.setLocale(this._i18service.language);

    this._translateService.onLangChange
      .pipe(takeUntilDestroyed())
      .subscribe((data: LangChangeEvent) => this._adapter.setLocale(data.lang));
  }

  public chosenYearHandler(normalizedYear: Moment): void {
    if (!this.noDays) {
      return;
    }

    const ctrlValue = moment();
    ctrlValue.year(normalizedYear.year());
    this.ctrl().setValue(ctrlValue);
  }

  public chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>): void {
    if (!this.noDays) {
      return;
    }

    const control = this.ctrl();

    const ctrlValue = control.value;
    ctrlValue.month(normalizedMonth.month());
    control.setValue(ctrlValue);
    datepicker.close();
  }
}
